import { createTheme } from "@mui/material/styles";

const darkText = "#F1F5F9";
const darkMuted = "#94A3B8";
const darkBg = "#0B0F14";
const darkPaper = "#151C26";
const darkHeader = "#111827";
const darkSidebar = "#0F141B";
const darkHover = "#1B2430";
const darkBorder = "#293241";
const darkPrimary = "#6366F1";
const darkPrimaryHover = "#818CF8";

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: darkPrimary,
      light: darkPrimaryHover,
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#94A3B8",
      contrastText: "#0B0F14",
    },
    background: {
      default: darkBg,
      paper: darkPaper,
    },
    text: {
      primary: darkText,
      secondary: darkMuted,
      disabled: "#64748B",
    },
    divider: darkBorder,
    error: {
      main: "#FB7185",
    },
    warning: {
      main: "#FBBF24",
    },
    success: {
      main: "#34D399",
    },
    info: {
      main: "#60A5FA",
    },
    action: {
      hover: "rgba(99, 102, 241, 0.14)",
      selected: "rgba(99, 102, 241, 0.22)",
      disabled: "#64748B",
      disabledBackground: darkHover,
    },
  },
  typography: {
    allVariants: {
      color: darkText,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: darkBg,
          color: darkText,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: darkPaper,
          color: darkText,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: darkHeader,
          color: darkText,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: darkSidebar,
          color: darkText,
          borderRight: `1px solid ${darkBorder}`,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: darkBg,
          color: darkText,
        },
        input: {
          color: darkText,
          WebkitTextFillColor: darkText,
          "&:-webkit-autofill": {
            WebkitBoxShadow: `0 0 0 100px ${darkBg} inset`,
            WebkitTextFillColor: darkText,
            caretColor: darkText,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: darkMuted,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: darkMuted,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: darkText,
          borderColor: darkBorder,
        },
        head: {
          color: darkText,
          fontWeight: 700,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: darkText,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: "#ffffff",
          "&:hover": {
            backgroundColor: darkPrimaryHover,
          },
        },
        outlined: {
          borderColor: darkPrimary,
          color: darkPrimaryHover,
        },
        text: {
          color: darkPrimaryHover,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: darkMuted,
        },
        colorPrimary: {
          color: darkPrimary,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: darkText,
        },
        secondary: {
          color: darkMuted,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: darkHover,
          color: darkText,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: darkPaper,
          color: darkText,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: darkPaper,
          color: darkText,
        },
      },
    },
  },
});
